import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USERINFO_FEATURE_KEY, UserInfoState } from './user-info.reducer';
import flatMap from 'lodash/flatMap';
import { ClientType } from '../interfaces';

// Lookup the 'UserInfo' feature state managed by NgRx
const getUserInfoState =
  createFeatureSelector<UserInfoState>(USERINFO_FEATURE_KEY);

const getLoaded = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.loaded,
);

const getProfile = createSelector(
  getUserInfoState,
  (state: UserInfoState) => state.userProfile,
);

const getFirstName = selectFromUserProfile('regFirstName');

const getLastName = selectFromUserProfile('regLastName');

const getRole = selectFromUserProfile('role');

const getStatus = selectFromUserProfile('status');

const getStateCodes = createSelector(getUserInfoState, (state: UserInfoState) =>
  flatMap(state.userProfile?.customerEligiblity?.clients?.client, (el) =>
    flatMap(el.customerAddresses?.address, (addr) => addr.state),
  ),
);

const getProductGroupTypes = createSelector(
  getUserInfoState,
  (state: UserInfoState) =>
    flatMap(state.userProfile?.customerEligiblity?.clients?.client, (el) =>
      flatMap(el.accounts?.account, (acc) =>
        flatMap(acc.coverages?.coverage, (cov) => cov.productGroupType),
      ),
    ),
);

const getPrimaryClientId = createSelector(
  getUserInfoState,
  (state: UserInfoState) =>
    getPrimaryClient(state.userProfile?.customerEligiblity?.clients?.client)
      ?.id,
);

export const userInfoQuery = {
  getLoaded,
  getProfile,
  getFirstName,
  getLastName,
  getRole,
  getStatus,
  getStateCodes,
  getProductGroupTypes,
  getPrimaryClientId,
};

function selectFromUserProfile<
  TProp extends keyof Exclude<ReturnType<typeof getProfile>, undefined>,
>(prop: TProp) {
  return createSelector(getProfile, (profile) =>
    profile ? profile[prop] : undefined,
  );
}

function getPrimaryClient(clients?: ClientType[]) {
  if (clients) {
    const primaryClient = clients.find((c) => c.primaryClient);

    return primaryClient ?? clients[0];
  }
}
